import { QStack, QButton, QCard, QText, QTitle } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type NoApiTokensProps = {
  handleDevPortalClick: () => void;
  goToCreate: () => void;
};

export const NoApiTokens: React.FC<NoApiTokensProps> = ({ handleDevPortalClick, goToCreate }) => {
  const { t } = useTranslation();

  return (
    <QCard>
      <QStack align="center" spacing={4} padding="40px">
        <QTitle>{t('emptyStates.noApiTokens.title')}</QTitle>
        <QText>{t('emptyStates.noApiTokens.subtitle')}</QText>
        <QStack direction={['column', 'row']} padding="20px">
          <QButton data-cy="dev-portal-link" variant="outline" onClick={handleDevPortalClick}>
            {t('emptyStates.noApiTokens.viewPortal')}
          </QButton>
          <QButton data-cy="create-token-button" onClick={goToCreate} leftIcon="Plus">
            {t('emptyStates.noApiTokens.createToken')}
          </QButton>
        </QStack>
      </QStack>
    </QCard>
  );
};
